import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AssetStatus, GalleryDto } from '@nusign/picflow-backend-types';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { AssetStatusButtonColorPipe } from '../../pipes/asset-status-button-color.pipe';
import { AssetStatusColorPipe } from '../../pipes/asset-status-color.pipe';
import { AssetStatusIconPipe } from '../../pipes/asset-status-icon.pipe';
import { AssetStatusNamePipe } from '../../pipes/asset-status-name.pipe';
import { AssetStatusOrderPipe } from '../../pipes/asset-status-order.pipe';
import { AssetStatusShortcutPipe } from '../../pipes/asset-status-shortcut.pipe';

@Component({
  selector: 'app-asset-status-button-extra-context',
  templateUrl: './asset-status-button-extra-context.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonMenuItemComponent,
    AssetStatusOrderPipe,
    AssetStatusNamePipe,
    AssetStatusIconPipe,
    AssetStatusShortcutPipe,
    AssetStatusColorPipe,
    AssetStatusButtonColorPipe,
  ],
})
export class AssetStatusButtonExtraContextComponent {
  @Input({ required: true }) gallery: GalleryDto;
  @Input({ required: true }) currentStatus: AssetStatus;
  @Input({ required: true }) location: string;
  @Output() onSelectStatus = new EventEmitter<AssetStatus>();
}
